// languages
export const LOCAL_STORAGE_LANG_KEY = 'medicare-paperless-lang';
export const LANGS_ENGLISH = 'en';
export const LANGS_SPANISH = 'sp';
export const LANGS_CHINESE = 'zh';

// consent
export const restrictedUrls = ['/', '/page-not-found', '/session-expired', '/auth/callback'];

export class AppConstants {

  static API_STEP_ELIGIBILITY = 'eligibility';
  static API_STEP_ATTESTATION_OF_ELIGIBILITY = 'attestation-of-eligibility';
  static API_STEP_PLAN_SELECTION = 'plan-selection';
  static API_STEP_APPLICANT_INFO = 'applicant-info';
  static API_STEP_MEDICARE_INFO = 'medicare-info';
  static API_STEP_PCP = 'pcp';
  static API_STEP_PAYMENT = 'payment';
  static API_STEP_REVIEW = 'review';
  // routes
  static INTRO_PAGE = '/intro';
  static DASHBOARD_PAGE = '/dashboard';
  static ELIGIBILITY_PAGE = `/application/${AppConstants.API_STEP_ELIGIBILITY}`;
  static ATTESTATION_OF_ELIGIBILITY_PAGE = `/application/${AppConstants.API_STEP_ATTESTATION_OF_ELIGIBILITY}`;
  static PLAN_SELECTION_PAGE = `/application/${AppConstants.API_STEP_PLAN_SELECTION}`;
  static APPLICANT_INFO_PAGE = `/application/${AppConstants.API_STEP_APPLICANT_INFO}`;
  static MEDICARE_INFO_PAGE = `/application/${AppConstants.API_STEP_MEDICARE_INFO}`;
  static PCP_PAGE = `/application/${AppConstants.API_STEP_PCP}`;
  static PAYMENT_PAGE = `/application/${AppConstants.API_STEP_PAYMENT}`;
  static REVIEW_PAGE = `/application/${AppConstants.API_STEP_REVIEW}`;
  static CONFIRMATION_PAGE = `/confirmation`;

  // attestation of eligibility options
  static ELIGIBILITY_REASON_ANNUAL = 'annual';
  static ELIGIBILITY_REASON_RECEIVED_PART_B = 'receivedPartB';
  static ELIGIBILITY_REASON_MOVED_OUTSIDE_THE_AREA = 'movedOutsideTheArea';
  static ELIGIBILITY_REASON_RELEASED_FROM_INCARCERATION = 'releasedFromIncarceration';
  static ELIGIBILITY_REASON_RETURNED_TO_US = 'returnedToUS';
  static ELIGIBILITY_REASON_OBTAINED_LAWFUL_STATUS = 'obtainedLawfulStatus';
  static ELIGIBILITY_REASON_HAS_MEDICARE_AND_MEDICAID = 'hasMedicareAndMedicaid';
  static ELIGIBILITY_REASON_GOT_EXTRA_HELP_WITH_PAYMENT = 'gotExtraHelpWithPayment';
  static ELIGIBILITY_REASON_LOST_EXTRA_HELP_WITH_PAYMENT = 'lostExtraHelpWithPayment';
  static ELIGIBILITY_REASON_MOVED_TO_LTC = 'movedToLTC';
  static ELIGIBILITY_REASON_LEFT_PACE = 'leftPACE';
  static ELIGIBILITY_REASON_LOST_DRUG_COVERAGE = 'lostDrugCoverage';
  static ELIGIBILITY_REASON_LEAVING_UNION_COVERAGE = 'leavingUnionCoverage';
  static ELIGIBILITY_REASON_QUALIFY_FOR_ENROLMENT = 'qualifyForEnrolment';
  static ELIGIBILITY_REASON_PHARMACY_ASSISTANCE_PROGRAM = 'pharmacyAssistanceProgram';
  static ELIGIBILITY_REASON_ENDS_CONTRACT_WITH_MEDICARE = 'endsContractWithMedicare';
  static ELIGIBILITY_REASON_DISENROLLED_FROM_SNP = 'disenrolledFromSNP';
  static ELIGIBILITY_REASON_OTHER = 'other';
  static ELIGIBILITY_REASON_IS_NEW_TO_MEDICARE = 'isNewToMedicare';
  static ELIGIBILITY_REASON_IS_ENROLLED_AND_WANTS_CHANGE = 'isEnrolledAndWantsChange';
  static ELIGIBILITY_REASON_RECENTLY_HAD_MEDICAID_CHANGE = 'recentlyHadMedicaidChange';
  static ELIGIBILITY_REASON_RECENTLY_HAD_MEDICAID_EXTRA_HELP_CHANGE = 'recentlyHadMedicaidExtraHelpChange';
  static ELIGIBILITY_REASON_UNDERSTANDS_PLAN_IS_DIFFERENT = 'understandsPlanIsDifferent';
  static ELIGIBILITY_REASON_UNABLE_TO_ENROLL_DUE_TO_DISASTER = 'unableToEnrollDueToDisaster';

  static MARITAL_STATUE_MARRIED = 'married';

  // medicare reasons
  static MEDICARE_REASON_ICEP = 'ICEP';
  static MEDICARE_REASON_OEP = 'OEP';
  static MEDICARE_REASON_SEP = 'SEP';
  static MEDICARE_REASON_AEP = 'AEP';

  // SEP reasons
  static SEP_REASON_LOW_INCOME = 'low_income';
  static SEP_REASON_HF_AREA = 'hf_area';
  static SEP_REASON_OTHER = 'other';

  static PRIVACY_POLICY_URL_MAPPING = (() => ({
    ['en']: 'https://healthfirst.org/online-privacy-policy-for-healthfirst-inc',
    ['sp']: 'https://es.healthfirst.org/online-privacy-policy-for-healthfirst-inc',
    ['zh']: 'https://zh.healthfirst.org/online-privacy-policy-for-healthfirst-inc',
  }))

  static TERMS_AND_CONDITIONS_URL_MAPPING = (() => ({
    ['en']: 'https://healthfirst.org/terms-of-use',
    ['sp']: 'https://es.healthfirst.org/terms-of-use',
    ['zh']: 'https://zh.healthfirst.org/terms-of-use',
  }))

  static NEW_YORK_PRIVACY_NOTICEY_URL_MAPPING = (() => ({
    ['en']: 'https://assets.healthfirst.org/pdf_53b845cf68',
    ['sp']: 'https://assets.healthfirst.org/pdf_cc1d76714e',
    ['zh']: 'https://assets.healthfirst.org/pdf_d57513f6dd',
  }))

  static HIPPA_PRIVACY_NOTICE_URL_MAPPING = (() => ({
    ['en']: 'https://assets.healthfirst.org/pdf_bdbbf2b17950a361672404fed5c33d90',
    ['sp']: 'https://assets.healthfirst.org/pdf_9a6c203fa4ad9f694ad7d2046b8c74dd',
    ['zh']: 'https://assets.healthfirst.org/pdf_ea7d8b80fb553148f2902c02606aeb51',
  }))

  static LOP_WITH_OPTIONAL_PCP = [
    'MPPO',
  ];

  // race/ethnicity not answered
  static RACE_NO_ANSWER = '999';
  static ETHNICITY_NO_ANSWER = 'NR';

  static AUTHORIZED_REP = 'authorized';

  static DIFFERENT_TERM_OPTION = '4';

  static APP_STATUS_PENDING = 'pending';
  static APP_STATUS_ARCHIVED = 'archived';
  static APP_STATUS_CANCELLED = 'cancelled';
  static APP_STATUS_SUBMITTED = 'submitted';

  static getStepsMapping = (() => [
    AppConstants.ELIGIBILITY_PAGE,
    AppConstants.ATTESTATION_OF_ELIGIBILITY_PAGE,
    AppConstants.MEDICARE_INFO_PAGE,
    AppConstants.PLAN_SELECTION_PAGE,
    AppConstants.APPLICANT_INFO_PAGE,
    AppConstants.PCP_PAGE,
    AppConstants.PAYMENT_PAGE,
    AppConstants.REVIEW_PAGE,
  ]);

  static getStepsApiMapping = (() => [
    AppConstants.API_STEP_ELIGIBILITY,
    AppConstants.API_STEP_ATTESTATION_OF_ELIGIBILITY,
    AppConstants.API_STEP_MEDICARE_INFO,
    AppConstants.API_STEP_PLAN_SELECTION,
    AppConstants.API_STEP_APPLICANT_INFO,
    AppConstants.API_STEP_PCP,
    AppConstants.API_STEP_PAYMENT,
    AppConstants.API_STEP_REVIEW,
  ]);

  static getStepsToApiValueMapping = (() => ({
    [AppConstants.ELIGIBILITY_PAGE]: AppConstants.API_STEP_ELIGIBILITY,
    [AppConstants.ATTESTATION_OF_ELIGIBILITY_PAGE]: AppConstants.API_STEP_ATTESTATION_OF_ELIGIBILITY,
    [AppConstants.MEDICARE_INFO_PAGE]: AppConstants.API_STEP_MEDICARE_INFO,
    [AppConstants.PLAN_SELECTION_PAGE]: AppConstants.API_STEP_PLAN_SELECTION,
    [AppConstants.APPLICANT_INFO_PAGE]: AppConstants.API_STEP_APPLICANT_INFO,
    [AppConstants.PCP_PAGE]: AppConstants.API_STEP_PCP,
    [AppConstants.PAYMENT_PAGE]: AppConstants.API_STEP_PAYMENT,
    [AppConstants.REVIEW_PAGE]: AppConstants.API_STEP_REVIEW,
  }));

  static getApiValueToStepsMapping = (() => ({
    [AppConstants.API_STEP_ELIGIBILITY]: AppConstants.ELIGIBILITY_PAGE,
    [AppConstants.API_STEP_ATTESTATION_OF_ELIGIBILITY]: AppConstants.ATTESTATION_OF_ELIGIBILITY_PAGE,
    [AppConstants.API_STEP_MEDICARE_INFO]: AppConstants.MEDICARE_INFO_PAGE,
    [AppConstants.API_STEP_PLAN_SELECTION]: AppConstants.PLAN_SELECTION_PAGE,
    [AppConstants.API_STEP_APPLICANT_INFO]: AppConstants.APPLICANT_INFO_PAGE,
    [AppConstants.API_STEP_PCP]: AppConstants.PCP_PAGE,
    [AppConstants.API_STEP_PAYMENT]: AppConstants.PAYMENT_PAGE,
    [AppConstants.API_STEP_REVIEW]: AppConstants.REVIEW_PAGE,
  }));

  static  APPLICATION_MATERIAL_IDS = {
    ['2023']: 'Y0147_ENR23_40 1330-22_C',
    ['2024']: 'Y0147_ENR24_25 1341-23_C',
    ['2025']: 'Y0147_ENR25_12 0963-24_M',
  };


  static languageMapping = (() => ({
    ['en']: 'english',
    ['sp']: 'spanish',
    ['zh']: 'chinese',
  }));
}
